import { countryInfoRussia } from '../../../constants/constants';
import { normalizeStr } from '../../../helpers/formatters';
import { convertFiasAddressItemToAddressItem } from './convertFiasAddressItemToAddressItem';
import { convertFiasRoomToSSFlat } from './convertFiasRoomToSSFlat';
import { convertFiasRoomToSSRoom } from './convertFiasRoomToSSRoom';
import { convertGarHouseToSSHouse } from './convertGarHouseToSSHouse';
export const convertFiasAddressToSSAddress = (fiasAddress) => {
    const country = fiasAddress?.country
        ? {
            name: fiasAddress.country.fullName || fiasAddress.country.code,
            code: fiasAddress.country.code,
        }
        : undefined;
    const text = normalizeStr(fiasAddress?.addressString.replace(/\n/g, ' '));
    const postalCode = fiasAddress.postalCode || undefined;
    const countryCode = fiasAddress?.country?.code || countryInfoRussia.code;
    if (countryCode !== countryInfoRussia.code) {
        return {
            country,
            text,
            postalCode,
        };
    }
    return {
        country,
        text,
        postalCode,
        region: convertFiasAddressItemToAddressItem(fiasAddress.address.region),
        municipalDistrict: convertFiasAddressItemToAddressItem(fiasAddress.address.municipaldistrict),
        district: convertFiasAddressItemToAddressItem(fiasAddress.address.district),
        city: convertFiasAddressItemToAddressItem(fiasAddress.address.city),
        intracityArea: convertFiasAddressItemToAddressItem(fiasAddress.address.intracityarea),
        urbanSettlement: convertFiasAddressItemToAddressItem(fiasAddress.address.urbansettlement),
        settlement: convertFiasAddressItemToAddressItem(fiasAddress.address.settlement),
        planningStructure: convertFiasAddressItemToAddressItem(fiasAddress.address.planningstructure),
        street: convertFiasAddressItemToAddressItem(fiasAddress.address.street),
        stead: convertFiasAddressItemToAddressItem(fiasAddress.address.stead),
        house: convertGarHouseToSSHouse(fiasAddress.address.garhouse),
        flat: convertFiasRoomToSSFlat(fiasAddress.address.room),
        room: convertFiasRoomToSSRoom(fiasAddress.address.room),
    };
};
